import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Search } from "lucide-react";

import { api } from "@/lib/api";
import { DossierItem } from "@/components/dossier-item";
import { TopBar } from "@/components/header";
import { ChipRow, Empty, ErrorView, Loading, SearchInput } from "@/components/kit";

const FILTERS = [
  { key: "all", label: "Tous" },
  { key: "mine", label: "Mes dossiers" },
  { key: "recu", label: "Nouveaux" },
  { key: "active", label: "Actifs" },
  { key: "devis", label: "Devis" },
  { key: "signe", label: "Signés" },
  { key: "commission_validee", label: "Com. validée" },
  { key: "commission_payee", label: "Payés" },
];

export default function AdminDossiers() {
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");
  const params = new URLSearchParams();
  if (filter === "mine") params.set("mine", "true");
  else if (filter !== "all") params.set("status", filter);
  if (search.trim()) params.set("q", search.trim());
  const q = useQuery({
    queryKey: ["admin-dossiers", filter, search.trim()],
    queryFn: () => api(`/admin/recommendations?${params.toString()}`),
    placeholderData: (prev) => prev,
  });
  return (
    <div data-testid="admin-dossiers-screen" className="flex flex-col">
      <TopBar title="Recommandations">
        <div className="mt-3 max-w-xl">
          <SearchInput icon={Search} testID="admin-dossiers-search-input" value={search} onChange={setSearch} placeholder="N° dossier, client, agent, ville…" />
        </div>
        <ChipRow options={FILTERS} value={filter} onChange={setFilter} testIDPrefix="admin-dossiers-filter" />
      </TopBar>
      {q.isLoading ? <Loading /> : q.isError ? <ErrorView message="Erreur de chargement." onRetry={() => q.refetch()} /> : (
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-3 p-4 pb-8 md:p-8">
          <p className="t-caption" data-testid="admin-dossiers-count">{q.data?.total ?? 0} dossier(s)</p>
          {q.data?.items?.length ? (
            <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
              {q.data.items.map((d) => <DossierItem key={d.id} d={d} admin />)}
            </div>
          ) : (
            <Empty title="Aucune recommandation" text="Les recommandations des agents apparaîtront ici." />
          )}
        </div>
      )}
    </div>
  );
}
